// extracted by mini-css-extract-plugin
module.exports = {"gw_underwriting_issues_warning_text":"UnderwritingIssues-hashed__gw_underwriting_issues_warning_text__3cHlb"};